<template>
  <div>
    <div @click="layerSelect">
      <img v-if="returnLanguage === 'en'" class="toggle-square" src="@/assets/images/climate-icon.jpg" :class="{ 'top-layer': layer === 'mexicoClimate' }" @click="changeLayer('mexicoClimate')" >
      <img v-if="returnLanguage === 'en'" class="toggle-square" src="@/assets/images/states-icon.jpg" :class="{ expanded: tilesExpanded, 'top-layer': layer === 'mexicoStates' }" @click="changeLayer('mexicoStates')" >
      <img v-if="returnLanguage === 'en'" class="toggle-square bottom" src="@/assets/images/terrain-icon.jpg" :class="{ expanded: tilesExpanded, 'top-layer': layer === 'mexicoTerrain' }" @click="changeLayer('mexicoTerrain')" >
      <img v-if="returnLanguage === 'es'" class="toggle-square" src="@/assets/images/climate-icon-es.jpg" :class="{ 'top-layer': layer === 'mexicoClimate' }" @click="changeLayer('mexicoClimate')" >
      <img v-if="returnLanguage === 'es'" class="toggle-square" src="@/assets/images/states-icon-es.jpg" :class="{ expanded: tilesExpanded, 'top-layer': layer === 'mexicoStates' }" @click="changeLayer('mexicoStates')" >
      <img v-if="returnLanguage === 'es'" class="toggle-square bottom" src="@/assets/images/terrain-icon-es.jpg" :class="{ expanded: tilesExpanded, 'top-layer': layer === 'mexicoTerrain' }" @click="changeLayer('mexicoTerrain')" >
    </div>
    <div id="climate-legend" :class="{ 'is-hidden': layer != 'mexicoClimate', expanded: legendExpanded }" @click="expandLegend">
        <div class="entry-container" v-for="entry in legendEntries" v-bind:key="entry.label" :class="{ expanded: legendExpanded }">
            <div class="color-tile" v-bind:style="{ background: entry.color }" :class="{ expanded: legendExpanded }"></div>
            <div class="layer-label" :class="{ expanded: legendExpanded }">{{ entry.label }}</div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LayerToggle',
  components: {
  },
  computed: {
    returnLanguage(){
      return this.$i18n.i18next.language
    },
    legendEntries(){
      if (this.$i18n.i18next.language === 'en'){
        return [{
          label: 'Tropical Wet',
          color: '#003811',
        },{
          label: 'Tropical wet-and-dry',
          color: '#7679d6',
        },{
          label: 'Semi-arid',
          color: '#e3e3a7',
        },{
          label:'Arid (desert',
          color: '#fbff22',
        },{
          label: 'Tmprate, dry winters',
          color: '#77bb10',
        },{
          label: 'Humid subtropical',
          color: '#0daab5',
        },{
          label: 'Mediterranean',
          color: '#ff0000',
        }]
      } else {
        return [{
          label: 'Tropical mojado',
          color: '#003811',
        },{
          label: 'Trpcl mojado-y-seco',
          color: '#7679d6',
        },{
          label: 'Semiárido',
          color: '#e3e3a7',
        },{
          label:'Árido (desierto)',
          color: '#fbff22',
        },{
          label: 'Templado',
          color: '#77bb10',
        },{
          label: 'Subtropical humedo',
          color: '#0daab5',
        },{
          label: 'Mediterráneo',
          color: '#ff0000',
        }]
      }
    }
  },
  mounted(){

  },
  props: {
  },
  data () {
    return {
        tilesExpanded: false,
        legendExpanded: false,
        layer: 'mexicoStates',
        
    }
  },
  methods: {
      layerSelect() {
        this.legendExpanded = false;
        this.tilesExpanded = !this.tilesExpanded;
      },
      changeLayer(layer) {
        if (this.tilesExpanded) {
          this.legendExpanded = false;
          this.$emit('change-layer', layer);
          this.layer = layer;
        }
      },
      expandLegend(){
        this.tilesExpanded = false;
        this.legendExpanded = !this.legendExpanded
      }
  }
}
</script>

<style lang="scss" scoped>

.toggle-square {
    height: 55px;
    width: 55px;
    background-color: black;
    box-sizing: border-box;
    border: 1px solid #FFFFF7;
    position: absolute;
    top: 100px;
    left: calc(100vw - 60px);
    z-index: 500;
    animation: slideUp 500ms;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;  
    box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.25);
}

.toggle-square.bottom {
    animation: slideUpBottom 500ms;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;  
}

.toggle-square.expanded {
    animation: slideDown 500ms;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;  
}

.toggle-square.expanded.bottom {
    animation: slideDownBottom 500ms;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;  
}

.top-layer {
    z-index: 600;
}

#climate-legend {
    height: 114px;
    width: 110px;
    position: relative;
    top: -158px;
    left: calc(100vw - 112px);
    background: rgba(255, 255, 247, .8);
    z-index: 500;
    animation: slideUpBottom 500ms;
    animation-iteration-count: 1;
    animation-fill-mode: forwards; 
    line-height: 14px;
    transition: all .4s ease-in-out;
}

#climate-legend.expanded {
  height: 171px;
  top: -215px;
  width: 165px;
  left: calc(100vw - 167px);
  background: rgba(255, 255, 247, 1);
  padding-top: 2px;
  padding-left: 2px;
  transition: all .4s ease-in-out;
}

.entry-container {
  display: flex;
  height: 16px;
  padding-top: 4px;
  transition: all .4s ease-in-out;
}

.entry-container.expanded {
  height: 24px;
}

.color-tile {
  height: 10px;
  width: 10px;
  display: inline-block;
  margin-right: 2px;
  margin-left: 2px;
  transition: all .4s ease-in-out;
}

.color-tile.expanded {
  height: 15px;
  width: 15px;

}


.is-hidden {
  display: none;
}

.layer-label {
  font-size: 10px;
  transition: all .4s ease-in-out;
  line-height: 1.2;
}

.layer-label.expanded {
  font-size: 15px;
  line-height: 1.1;
}

@keyframes slideDown {
  0% {
    transform: translateY(0);    
  }
  100% {
    transform: translateY(65px);
  }
}

@keyframes slideDownBottom {
  0% {
    transform: translateY(0);    
  }
  100% {
    transform: translateY(130px);
  }
}

@keyframes slideUp {
  0% {
    transform: translateY(65px);    
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes slideUpBottom {
  0% {
    transform: translateY(130px);    
  }
  100% {
    transform: translateY(0);
  }
}


</style>
